import {EditorView} from "prosemirror-view";
import {EditorState, TextSelection, Transaction} from "prosemirror-state";


import {replaceSelectionParagraphWithNode, replaceTextRangeWithNode} from "./utils";


import {schema} from "../../config/schema";
import {TriggerActionCommandAdditionalParams} from "./types";


export const insertHorizontalLine = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: TriggerActionCommandAdditionalParams) => {
    let tr = getInsertHorizontalLineTransaction(state, additionalParams);

    if (tr && tr !== state.tr) {
        dispatch && dispatch(tr);

        // Focus on the view
        view?.focus();

        return true;
    }
    return false;
}

export const getInsertHorizontalLineTransaction = (state: EditorState, additionalParams?: TriggerActionCommandAdditionalParams) => {
    const horizontalRuleNode = schema.nodes.horizontalRule.create();
    const targetPos = state.selection.$to.after();
    let tr;
    if ((additionalParams?.nodePos !== undefined) && (additionalParams?.textInput !== undefined)) {
        tr = replaceTextRangeWithNode(state, additionalParams.nodePos, additionalParams.nodePos + additionalParams.textInput.length + 1, horizontalRuleNode, true);
    } else {
        tr = replaceSelectionParagraphWithNode(state, horizontalRuleNode, true)
    }

    if (tr !== state.tr) {
        const posAfterHorizontalRule = tr.mapping.map(targetPos);

        const paragraphNode = schema.nodes.paragraph.create();

        tr = tr.insert(posAfterHorizontalRule, paragraphNode);

        tr = tr.setSelection(TextSelection.near(tr.doc.resolve(
            posAfterHorizontalRule + paragraphNode.nodeSize - 1,
        )));

        return tr;
    }
    return null;
}
